<template>
	<div>
		<progress-bar
			:isLoading="loading"
		/>

		<alert-basic
			:show="alert.show"
			:message="alert.message"
			:type="alert.type"
		/>

		<h1>Important notes</h1>
		<ul align="left">
			<li>Make changes only if you are fully aware of the consequences</li>
			<li>Revenue Report activation means that the overnight import is activated for the current customer. <strong>If deactivated, no revenue data will be imported from that point on.</strong></li>
			<li>The overnight import also triggers the sales cube creation</li>
			<li>If the message is activated, a message will be displayed to the customer:" We experience and error. No data since DD-MM-YYYY. We try to make it work as soon as possible"</li>
			<li>The data picker sets the date in the above message.</li>
		</ul>
		<v-btn class="getRevenueItemsForConfigButton" outlined @click="getInstallationData" >{{txt.btn.getRevenueConfig}}</v-btn>
		<installation-revenue-config
			:renderKey="renderKey"
			:installationData="installations"
			@changesMade="getInstallationData"
		/>

	</div>
</template>

<script>
import axios from 'axios'
import installationRevenueConfig from './installationRevenueConfig.vue'
import ProgressBar from '../../vueBasics/Progressbar.vue'
import AlertBasic from '../../vueBasics/AlertBasic.vue'

export default {
	components: {
		installationRevenueConfig,
		ProgressBar,
		AlertBasic,
	},
	data(){
		return {
			renderKey: 0,
			installations: [],
			loading: false,
			txt: {
				btn: {
					getRevenueConfig: 'Get Revenue Config'
				}
			},
			alert: {
				show: false,
				message: '',
				type: 'info'
			}
		}
	},
	methods: {
		async getInstallationData(){
			try {
				this.loading = true
				let res = await axios.get(config.baseAPIurl + '/admin-page/revenue-config')
				this.installations = res.data
				this.alert.message = 'Loaded'
				this.alert.type = 'success'
				this.alert.show = true
				this.loading = false
			} catch (error) {
				this.alert.message = 'Error'
				this.alert.type = 'error'
				this.alert.show = true
				this.loading = false
			}
			setTimeout(() => {
				this.alert.show = false
			}, 5000)
		}
	},
	watch: {
		"installations": {
			handler: function(){
				this.renderKey += 1
			}
		}
	}
}
</script>

<style>
.getRevenueItemsForConfigButton{
	margin: 25px;
	background-color: rgb(245, 245, 245);
}
</style>